import styles from "@/components/modal/share-voice/styles/share-voice-modal.module.scss";
import StyledInput from "@/components/common/input/styled-input";
import FilledButton from "@/components/common/filled-button";
import { useShareVoice } from "@/components/modal/share-voice/hooks/use-share-voice";
import { VoiceModel } from "@/actions/db/get-models";
import { ToastContainer } from "react-toastify";

type ShareVoiceModalProps = {
  voiceModel: VoiceModel;
};

const ShareVoiceModal = ({ voiceModel }: ShareVoiceModalProps) => {
  const { email, handleEmailChanged, isEmailValid, sendEmail, isSending } =
    useShareVoice();

  return (
    <>
      <ToastContainer position={"bottom-center"} />
      <div className={styles.wrapper}>
        <div className={styles.header_wrapper}>
          <div className={styles.header_text}>Share your voice</div>
          <div className={styles.description_text}>
            Invite your friends to use your voice! Add their email addresses
            below. Even if they don&apos;t have an account, the&apos;ll receive
            an email with a link to use your voice. This action will
            automatically make the voice public.
          </div>
        </div>
        <div className={styles.input_wrapper}>
          <StyledInput
            value={email}
            onChange={handleEmailChanged}
            placeholder={"Enter email address"}
            isValid={isEmailValid}
          />
          <FilledButton
            text={"SEND"}
            onClick={() => sendEmail(voiceModel)}
            disabled={!isEmailValid || isSending}
            backgroundColor={"#141414"}
            borderColor={"#3F3F3F"}
            color={"#F2F2F2"}
            hoveringColor={"#F2F2F2"}
          />
        </div>
      </div>
    </>
  );
};

export default ShareVoiceModal;
